export default __webpack_public_path__ + "static/media/loading.1c6e3d8c.svg";